const Company = {

    // FIELDS
    "name": "Name",
    "address": "Address",
    "postal_code": "Postal Code",
    "website": "Website",
    "email": "Email",
    "telephone": "Telephone Number",
    "mobile_no": "Mobile Number",
    "fax": "Fax",
    "logo": "Logo",
    "type_of_company": "Company Type",
    "pan_no": "Pan Number",
    "state": "State",
    "city": "City",
    "country": "Country",
    "search": "Search",

    // PAGE HEADER
    "company": "Company",

    // ERROR
    "error_name": "Enter Name",
    "error_address": "Enter Address",
    "error_postal_code": "Enter Postal Code",
    "error_website": "Link is required",
    "error_email": "Enter Email",
    "error_telephone": "Enter Telephone Number",
    "error_mobile_no": "Enter Mobile Number",
    "error_fax": "Enter Fax",
    "error_logo": "Logo is Required",
    "error_type_of_company": "Enter Company Type",
    "error_pan_no": "Enter PAN Number",
    "error_country": "Select Country",
    "error_state": "Select State",
    "error_city": "Select City",
    "error_min": "Must be exactly 10 digits",
    "error_max": "Must be exactly 15 digits",
    "error_matches_pan": "Invalid PAN",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_city": "CITY",
    "table_mobile_no": "MOBILE",

}

export default Company;